import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import LoadScript from "vue-plugin-load-script";
import ElementUI from "element-ui";
import VueClipboard from "vue-clipboard2";

import i18n from "@/plugins/i18n.js";
import router from "@/plugins/router.js";
import SvgIcon from "vue-svgicon";

import Layout from "@/components/layout/Layout";
import LayoutDataset from "@/components/layout/Datasets";
import Components from "./ui-library/index.js";
import store from "@/store";

import "./styles/style.scss";

Vue.use(VueAxios, axios);

Vue.use(ElementUI);
Vue.use(Components);
Vue.use(VueClipboard);
Vue.use(VueMeta);
Vue.use(LoadScript);

Vue.use(SvgIcon, {
  tagName: "svgicon"
});

Vue.config.productionTip = false;

Vue.prototype.organizationConfig = window._organizationConfig;

Vue.component("Layout", Layout);
Vue.component("LayoutDataset", LayoutDataset);

new Vue({
  i18n,
  router,
  store,
  render: h => h("router-view"),
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event("x-app-rendered"));
  }
}).$mount("#app");
